// extracted by mini-css-extract-plugin
export default {"controls":"CommentAdd_controls__bzZs6","field":"CommentAdd_field__AYLY8"};